module.exports = __webpack_public_path__ + "img/generalhelpicon.801b765d.svg";